import SelfInstallation from './SelfInstallation';

export default SelfInstallation;
